import { FC } from "react";

import { ProcedureFolderNode } from "@/model/Procedure/ProcedureFolderNode";

export interface IProcedurNodeFolderItemProps {
  Folder: ProcedureFolderNode;
}

export const ProcedureNodeFolderItem: FC<IProcedurNodeFolderItemProps> = (
  props,
) => {
  const getIndentation = (level: number) => {
    return "\u00A0\u00A0".repeat(level);
  };

  return (
    <option value={props.Folder.GroupNumber} key={props.Folder.GroupNumber}>
      {getIndentation(props.Folder.Level)}
      {props.Folder.Name}
    </option>
  );
};
